import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { colors } from 'theme/Variables';

const LinkButton = styled(Link)`
    background-color: ${colors.primary['900']};
    color: ${colors.white};
    font-size: 1.6rem;
    text-decoration: none;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
        0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    font-weight: 700;
    line-height: 1.75;
    border-radius: 15px;
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
        box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
        border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    padding: 6px 16px;
    min-width: 64px;
    width: ${({ width }) => (width ? `${width}%` : '100%')};
    text-align: center;
    &:hover,
    &:focus,
    &:active {
        background-color: rgb(10, 16, 70);
    }
`;

export default LinkButton;
